import { useState } from 'react';

export default function WhatsAppButton() {
  const [hovered, setHovered] = useState(false);

  return (
    <div className="fixed bottom-8 right-8 z-50 flex items-center gap-3">
      {/* Tooltip */}
      <div
        className={`bg-deep border border-gold/20 text-ice/80 font-sans text-xs font-400 px-4 py-2 rounded-md whitespace-nowrap transition-all duration-300 ${
          hovered ? 'opacity-100 translate-x-0' : 'opacity-0 translate-x-2 pointer-events-none'
        }`}
      >
        Fale com um Advogado
        <div className="absolute right-0 top-1/2 -translate-y-1/2 translate-x-full w-0 h-0 border-t-4 border-b-4 border-l-4 border-transparent" style={{ borderLeftColor: 'rgba(200,162,74,0.2)' }} />
      </div>

      {/* Button */}
      <a
        href="https://wa.me/5598981578332?text=Olá,%20gostaria%20de%20falar%20com%20um%20advogado."
        target="_blank"
        rel="nofollow noopener noreferrer"
        onMouseEnter={() => setHovered(true)}
        onMouseLeave={() => setHovered(false)}
        className="relative w-16 h-16 flex items-center justify-center rounded-full bg-gold hover:bg-gold-light cursor-pointer transition-all duration-300"
        style={{
          boxShadow: hovered
            ? '0 0 0 8px rgba(200,162,74,0.15), 0 8px 32px rgba(200,162,74,0.5)'
            : '0 0 0 0px rgba(200,162,74,0), 0 4px 20px rgba(200,162,74,0.4)',
          transform: hovered ? 'scale(1.1)' : 'scale(1)',
        }}
        aria-label="Conversar no WhatsApp com Benner Martins Advocacia"
      >
        <i className="ri-whatsapp-line text-deep text-2xl" />
        {/* Pulse ring */}
        <span
          className="absolute inset-0 rounded-full animate-ping"
          style={{ background: 'rgba(200,162,74,0.25)', animationDuration: '2.5s' }}
        />
      </a>
    </div>
  );
}
